<template>
  <div
    v-if="visible"
    :class="[
      'flex-shrink-0',
      sticky ? 'sticky top-0 z-20 bg-white/95 backdrop-blur-sm border-b border-indigo-100 shadow-sm' : '',
      wrapperClass,
    ]"
  >
    <div
      :class="[
        'flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between',
        sticky ? 'px-4 py-3' : 'px-4 py-3 rounded-xl border border-indigo-100 bg-indigo-50/80',
      ]"
    >
      <div class="min-w-0 flex-1">
        <p class="text-sm font-semibold text-gray-900">{{ t('colivingSearch.noResultsCta.title') }}</p>
        <p class="text-xs text-gray-500 mt-0.5">
          {{ t('colivingSearch.noResultsCta.subtitle') }}
          <span class="font-medium text-indigo-700">{{ city }}</span>
        </p>
        <p v-if="operatorsCount >= 2" class="text-xs text-orange-700 font-medium mt-1">
          {{ t('colivingSearch.noResultsCta.scarcityMany', { count: operatorsCount, city }) }}
        </p>
        <p v-else-if="operatorsCount === 1" class="text-xs text-orange-700 font-medium mt-1">
          {{ t('colivingSearch.noResultsCta.scarcityOne', { count: operatorsCount, city }) }}
        </p>
        <button
          v-if="hasSessionProfile"
          type="button"
          class="text-xs text-indigo-600 hover:text-indigo-800 underline mt-1 text-left"
          @click="$emit('change-data')"
        >
          {{ t('scrapedLeadModal.changeSessionData') }}
        </button>
      </div>
      <button
        type="button"
        class="w-full sm:w-auto flex-shrink-0 px-4 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-full transition-colors shadow-sm whitespace-nowrap text-center"
        @click="$emit('action')"
      >
        {{ t('colivingSearch.noResultsCta.button') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  visible: { type: Boolean, default: true },
  city: { type: String, default: '' },
  operatorsCount: { type: Number, default: 0 },
  sticky: { type: Boolean, default: false },
  wrapperClass: { type: String, default: '' },
  hasSessionProfile: { type: Boolean, default: false },
});

defineEmits(['action', 'change-data']);

const { t } = useI18n();
</script>
